import React, { useId, useState } from 'react';
import { REGIME_ROWS, STOCK_BOND_INTRO } from '../utils/stockBondCorrelationSignal';

function StockBondCorrelationHelp() {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div className="stock-bond-help">
      <button
        type="button"
        className="stock-bond-help-trigger"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        How to read this
      </button>
      {open && (
        <div id={panelId} className="stock-bond-help-panel" role="region" aria-label="Stock-bond correlation guide">
          <p className="stock-bond-help-body">{STOCK_BOND_INTRO}</p>
          <table className="stock-bond-regime-table">
            <thead>
              <tr>
                <th>Correlation</th>
                <th>Regime</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              {REGIME_ROWS.map((row) => (
                <tr key={row.id}>
                  <td>{row.range}</td>
                  <td>
                    {row.emoji} {row.label}
                  </td>
                  <td>{row.tooltip}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default StockBondCorrelationHelp;
